import { ProjectQuery } from '~/@store/projects';
import client from '~/apolloClient';
import {
    CreateTimeSpentFromProjectMutation,
    CreateTimeSpentFromProjectMutationVariables,
    DeleteTimeSpentFromProjectMutation,
    DeleteTimeSpentFromProjectMutationVariables,
    TimeSpentCreateInput,
    TimeSpentUpdateInput,
    UpdateTimeSpentFromProjectMutation,
    UpdateTimeSpentFromProjectMutationVariables,
} from '~/graphql';
import { handleApolloError } from '~/utils';

import * as timeSpentQueries from './timeSpent.queries';

export const createTimeSpentFromProject = (projectId: string, input: TimeSpentCreateInput) =>
    client
        .mutate<CreateTimeSpentFromProjectMutation, CreateTimeSpentFromProjectMutationVariables>({
            mutation: timeSpentQueries.CreateTimeSpentFromProjectMutation,
            variables: { input },
            refetchQueries: [{ query: ProjectQuery, variables: { id: projectId } }],
        })
        .catch(handleApolloError)
        .then(res => res.data?.timeSpentCreate || Promise.reject(new Error('empty response')));

export const updateTimeSpentFromProject = (projectId: string, id: string, input: TimeSpentUpdateInput) =>
    client
        .mutate<UpdateTimeSpentFromProjectMutation, UpdateTimeSpentFromProjectMutationVariables>({
            mutation: timeSpentQueries.UpdateTimeSpentFromProjectMutation,
            variables: { id, input },
            refetchQueries: [{ query: ProjectQuery, variables: { id: projectId } }],
        })
        .catch(handleApolloError)
        .then(res => res.data?.timeSpentUpdate || Promise.reject(new Error('empty response')));

export const deleteTimeSpentFromProject = (projectId: string, id: string) =>
    client
        .mutate<DeleteTimeSpentFromProjectMutation, DeleteTimeSpentFromProjectMutationVariables>({
            mutation: timeSpentQueries.DeleteTimeSpentFromProjectMutation,
            variables: { id },
            refetchQueries: [{ query: ProjectQuery, variables: { id: projectId } }],
        })
        .catch(handleApolloError)
        .then(res => res.data?.timeSpentRemove || Promise.reject(new Error('empty response')));
